<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_operation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="operation_image_show"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.image')"
            :disabled="true"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.title_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.title_en"
            disabled
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model="data.description_ar"
            disabled
          />
          <base-text-editor
            col="6"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model="data.description_en"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowOperation",

  data() {
    return {
      data: {
        image: { path: null, file: null },
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
      },
    };
  },

  methods: {
    async getData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `operations/${this.$route.params.id}`,
        });
        const item = res.data?.data?.Operation || {};
        this.data.image.path = item.image;
        this.data.title_ar = item.title_ar;
        this.data.title_en = item.title_en;
        this.data.description_ar = item.description_ar;
        this.data.description_en = item.description_en;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load operation details"
        );
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
